import ShiftFormTrackingIdMapping from './ShiftFormTrackingIdMapping';
import MaseratiFormTrackingIdMapping from './MaseratiFormTrackingIdMapping';

export default {
	ShiftFormTrackingIdMapping,
	MaseratiFormTrackingIdMapping
};
